<template class="h-100 w-100">
        <v-card class="w-100 h-100 pa-10" elevation="0" style="font-family: 'PT Sans', sans-serif; background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);">
        <v-card-text>
            <h1 class="text-center mb-2" style="font-family: 'PT Sans', sans-serif; font-weight: 700; color: #2e7d32;">Your subscription</h1>
            <p class="text-center mb-8" style="font-family: 'PT Sans', sans-serif; font-size: 18px; color: #666;">Choose a plan that seems right for you!</p>
            <v-row class="justify-center" no-gutters style="margin-top: 40px;">
                <v-col cols="12" sm="6" md="4" lg="4" class="px-3 mb-6">
                    <v-card 
                        class="plan-card h-100 d-flex flex-column" 
                        elevation="8"
                        style="border-radius: 16px; background: linear-gradient(135deg, #2e7d32 0%, #4caf50 100%); min-height: 520px; margin-top: 20px;">
                        <v-card-title class="text-center py-8">
                            <h2 style="font-family: 'PT Sans', sans-serif; font-weight: 700; color: white; font-size: 28px;">Basic User</h2>
                        </v-card-title>
                        <v-card-text class="flex-grow-1 d-flex flex-column justify-space-between pa-6">
                            <ul class="plan-features" style="font-size: 14pt; color: white; list-style: none; padding: 0; flex-grow: 1;">
                                <li class="my-4 d-flex align-center">
                                    <v-icon class="mr-3" color="white" size="20">mdi-check-circle</v-icon>
                                    Access to WildTrackPro
                                </li>
                                <li class="my-4 d-flex align-center">
                                    <v-icon class="mr-3" color="white" size="20">mdi-check-circle</v-icon>
                                    Create and manage organisations
                                </li>
                                <li class="my-4 d-flex align-center">
                                    <v-icon class="mr-3" color="white" size="20">mdi-check-circle</v-icon>
                                    Review and manage your own data
                                </li>
                                <li class="my-4 d-flex align-center">
                                    <v-icon class="mr-3" color="white" size="20">mdi-check-circle</v-icon>
                                    <b>1</b> &nbsp;site limit
                                </li>
                            </ul>
                            <v-btn 
                                block
                                color="white"
                                variant="elevated"
                                size="large"
                                class="mt-6 plan-button"
                                style="color: #2e7d32; font-weight: 600; border-radius: 12px; font-family: 'PT Sans', sans-serif;"
                                @click="openPricing('https://buy.stripe.com/5kA4jreMfdJieS4145')">
                                Choose Basic Plan
                            </v-btn>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="4" class="px-3 mb-6" style="position: relative;">
                    <v-card 
                        class="plan-card h-100 d-flex flex-column popular-card" 
                        elevation="16"
                        style="border-radius: 16px; background: linear-gradient(135deg, #1b5e20 0%, #2e7d32 100%); min-height: 520px; border: 3px solid #4caf50; margin-top: 20px;">
                        <v-card-title class="text-center py-8 position-relative">
                            <h2 style="font-family: 'PT Sans', sans-serif; font-weight: 700; color: white; font-size: 32px; text-shadow: 0 2px 4px rgba(0,0,0,0.3);">Advanced User</h2><v-chip 
                        class="popular-badge" 
                        color="#4caf50" 
                        size="small"
                        style="position: absolute; top: 10px; right: 10px; font-weight: 700; z-index: 10; box-shadow: 0 4px 12px rgba(76, 175, 80, 0.4);">
                        ⭐ POPULAR ⭐
                    </v-chip>
                        </v-card-title>
                        <v-card-text class="flex-grow-1 d-flex flex-column justify-space-between pa-6">
                            <ul class="plan-features" style="font-size: 14pt; color: white; list-style: none; padding: 0; flex-grow: 1;">
                                <li class="my-4 d-flex align-center">
                                    <v-icon class="mr-3" color="white" size="20">mdi-check-circle</v-icon>
                                    Access to the culls database
                                </li>
                                <li class="my-4 d-flex align-center">
                                    <v-icon class="mr-3" color="white" size="20">mdi-check-circle</v-icon>
                                    Access to advanced stats and document management
                                </li>
                                <li class="my-4 d-flex align-center">
                                    <v-icon class="mr-3" color="white" size="20">mdi-check-circle</v-icon>
                                    Everything included in previous tiers
                                </li>
                                <li class="my-4 d-flex align-center">
                                    <v-icon class="mr-3" color="white" size="20">mdi-check-circle</v-icon>
                                    <b>1</b> &nbsp;site limit, 100HA woodland
                                </li>
                            </ul>
                            <v-btn 
                                block
                                color="#4caf50"
                                variant="elevated"
                                size="x-large"
                                class="mt-6 plan-button premium-button"
                                style="color: white; font-weight: 700; border-radius: 12px; font-family: 'PT Sans', sans-serif; font-size: 16px; background: linear-gradient(135deg, #4caf50 0%, #66bb6a 100%); box-shadow: 0 8px 25px rgba(76, 175, 80, 0.4);"
                                @click="openPricing('https://buy.stripe.com/9AQbLT9rV8oYdO0cMP')">
                                🚀 Choose Advanced Plan
                            </v-btn>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="4" class="px-3 mb-6">
                    <v-card 
                        class="plan-card h-100 d-flex flex-column" 
                        elevation="8"
                        style="border-radius: 16px; background: linear-gradient(135deg, #2e7d32 0%, #4caf50 100%); min-height: 520px; margin-top: 20px;">
                        <v-card-title class="text-center py-8">
                            <h2 style="font-family: 'PT Sans', sans-serif; font-weight: 700; color: white; font-size: 28px;">Syndicate</h2>
                        </v-card-title>
                        <v-card-text class="flex-grow-1 d-flex flex-column justify-space-between pa-6">
                            <ul class="plan-features" style="font-size: 14pt; color: white; list-style: none; padding: 0; flex-grow: 1;">
                                <li class="my-4 d-flex align-center">
                                    <v-icon class="mr-3" color="white" size="20">mdi-check-circle</v-icon>
                                    Access to the culls database
                                </li>
                                <li class="my-4 d-flex align-center">
                                    <v-icon class="mr-3" color="white" size="20">mdi-check-circle</v-icon>
                                    Access to advanced stats and document management
                                </li>
                                <li class="my-4 d-flex align-center">
                                    <v-icon class="mr-3" color="white" size="20">mdi-check-circle</v-icon>
                                    Everything included in previous tiers
                                </li>
                                <li class="my-4 d-flex align-center">
                                    <v-icon class="mr-3" color="white" size="20">mdi-check-circle</v-icon>
                                    <b>3</b> &nbsp;site limit
                                </li>
                            </ul>
                            <v-btn 
                                block
                                color="white"
                                variant="elevated"
                                size="large"
                                class="mt-6 plan-button"
                                style="color: #2e7d32; font-weight: 600; border-radius: 12px; font-family: 'PT Sans', sans-serif;"
                                @click="openPricing('https://buy.stripe.com/bIYdU1dIb20AcJW005')">
                                Choose Syndicate Plan
                            </v-btn>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
            <p class="text-center mt-8" style="font-size: 16pt; color: #666; font-family: 'PT Sans', sans-serif;">
                If you already have a subscription you don't need to do anything else. If you would like to upgrade your existing plan please contact us at: 
                <a href="mailto:info@wildtrackpro.com" style="color: #4caf50; text-decoration: none; font-weight: 600;">info@wildtrackpro.com</a>
            </p>
            
            <v-divider class="my-8" style="border-color: #4caf50; opacity: 0.3;"></v-divider>
        </v-card-text>
      </v-card>
</template>
<script>
    export default {
        data() {
            return {
                username: null,
            }
        },
        methods: {
            openPricing(url) {
                window.open(url, '_blank');
            }
        },
        beforeMount() {
            this.username = localStorage.getItem('username')
        },
    }
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=PT+Sans:wght@400;700&display=swap');

.plan-card {
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    transform: scale(1);
}

.plan-card:hover {
    transform: scale(1.02);
    box-shadow: 0 12px 40px rgba(76, 175, 80, 0.3) !important;
}

.popular-card {
    transform: scale(1.05);
}

.popular-card:hover {
    transform: scale(1.08) !important;
    box-shadow: 0 20px 60px rgba(76, 175, 80, 0.5) !important;
}

.plan-button {
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.plan-button:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);
}

.premium-button {
    animation: glow 2s ease-in-out infinite alternate;
}

.premium-button:hover {
    transform: translateY(-3px) !important;
    box-shadow: 0 12px 35px rgba(76, 175, 80, 0.6) !important;
}

@keyframes glow {
    from {
        box-shadow: 0 8px 25px rgba(76, 175, 80, 0.4);
    }
    to {
        box-shadow: 0 8px 25px rgba(76, 175, 80, 0.6);
    }
}

.plan-features li {
    transition: all 0.2s ease;
}

.plan-features li:hover {
    transform: translateX(5px);
}

.popular-badge {
    animation: pulse 2s infinite;
    font-size: 11px !important;
}

.popular-badge .v-chip__content {
    padding: 0 8px !important;
}

@keyframes pulse {
    0% {
        box-shadow: 0 4px 12px rgba(76, 175, 80, 0.4);
    }
    50% {
        box-shadow: 0 6px 20px rgba(76, 175, 80, 0.6);
        transform: scale(1.05);
    }
    100% {
        box-shadow: 0 4px 12px rgba(76, 175, 80, 0.4);
    }
}

/* Mobile responsiveness */
@media (max-width: 960px) {
    .plan-card {
        margin-bottom: 20px;
    }
}

@media (max-width: 600px) {
    .v-card-text {
        padding: 20px !important;
    }
    
    .plan-features {
        font-size: 12pt !important;
    }
    
    h2 {
        font-size: 20px !important;
    }
}
</style>